<template>
<div class="page-container">
    <el-container>
    <el-header>
      <Myheader pageType="subpage" :selectIndex="selectIndex" v-on:goHome="goHome"></Myheader>
    </el-header>
    <div class="banner">
      <img src="../../../static/images/news-dtl-banner.png"  style="width: 100%;">
      <p class="type-title">{{ pageTitle }}</p>
    </div>
    <el-main>
      <div class="page-navugation" :class="{'mobile-width':mobilePage}">
        <el-row>
          <el-col :span="12">
            <div class="navugation-left">
              <label class="navugation-root">新闻动态 ></label><label  class="navugation-cuur"> {{pageName}}</label>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="navugation-right">
              <el-input type="text" placeholder="请输入想要搜索的内容" name="queryKey" style="width:260px;" v-model="queryParamters.queryKey">
                <el-button type="primary" slot="append" icon="el-icon-search" @click="queryData"></el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="page-content" v-loading = "listLoad" :class="{'mobile-width':mobilePage}">
          <div v-if="resultList && resultList.length>0">
            <div>
              <el-row :gutter="12" class="result-item" v-for="(resultItem,index) in resultList" :key="index">
              <el-col :span="6" class="result-item-img" >
                  <img :src="resultItem.Path"  @click="gotoNewsDetal(resultItem.NID)">
              </el-col>
              <el-col :span="18" class="result-item-text">
                  <el-col :span="24" class="result-item-title multiline-overflow">
                    <div @click="gotoNewsDetal(resultItem.NID)">{{ resultItem.NTITLE }}</div>
                  </el-col>
                  <el-col :span="24" class="result-item-content multiline-overflow" >
                    <div @click="gotoNewsDetal(resultItem.NID)" v-html="resultItem.NCONTENT"></div>
                  </el-col>
                  <el-col :span="24" class="result-item-date">{{ resultItem.NDATETIME }}</el-col>
              </el-col>
            </el-row>
          </div>
        </div>
        <el-empty v-else style="width: 100%;" description="暂无数据"></el-empty>
      </div>
    </el-main>
    <div  style="padding: 15px;" v-if="resultList && resultList.length>0">
      <el-pagination class="pagination-cust" :class="{'mobile-width':mobilePage}"
            @size-change="handleSizeChange"
            @current-change="handleCurrChange"
            :current-page="queryParamters.pageIndex"
            :page-sizes="[10,20,30,50,,80,100]"
            :page-size="queryParamters.pageSize"
            layout="total,sizes,prev,pager,next,jumper"
            :total="queryParamters.totalNum"></el-pagination>
    </div>
    <Mybottom/>
    </el-container>
</div>
</template>

<script>
import Mybottom from '@/components/pageBottom/bottom.vue'
import Myheader from '@/components/pageHeader/header.vue'
import { queryNewsPageList } from '@/api/api.js'
import { getSign } from '@/utils/md5.js'
import { Message } from 'element-ui'
export default {
  name: 'newsList',
  data () {
    return {
      mobilePage: false,
      pageTitle: '新闻动态',
      pageName: '公司新闻',
      listLoad: false,
      selectIndex: 3,
      queryParamters: {
        queryKey: '',
        queryType: '0',
        pageIndex: 1,
        pageSize: 10,
        totalNum: 0
      },
      resultList: [
      ]
    }
  },
  components: {
    Mybottom,
    Myheader
  },
  mounted () {
    if (navigator.userAgent.match(/mobile/i)) {
      this.mobilePage = true
    }
  },
  created () {
    const typeDes = this.$route.query.type
    this.id = this.$route.query.id
    if (typeDes === '1') {
      this.pageTitle = '公司新闻'
      this.pageName = '公司新闻'
      this.queryParamters.queryType = '0'
    } else {
      this.pageTitle = '行业动态'
      this.pageName = '行业动态'
      this.queryParamters.queryType = '1'
    }
    this.initList()
  },
  methods: {
    goHome (partId) {
      this.$router.push({path: '/', query: {partId: partId}})
    },
    queryData () {
      this.queryParamters.pageIndex = 1
      this.resultList = []
      this.initList()
    },
    initList () {
      let that = this
      that.listLoad = true
      var paramters = {
        title: that.queryParamters.queryKey,
        type: that.queryParamters.queryType,
        pageIndex: that.queryParamters.pageIndex,
        pageSize: that.queryParamters.pageSize
      }
      const jsonData = encodeURIComponent(JSON.stringify(paramters))
      const sign = getSign('getNewsPageList')
      that.$http({
        url: queryNewsPageList + '?Operation=getNewsPageList&jsonData=' + jsonData + '&sign=' + sign,
        method: 'get'
      }).then(({ data }) => {
        // 处理
        that.listLoad = false
        if (data.Code === 200) {
          var tableList = data.Data.Table
          var listInfo = data.Data.Table1
          if (tableList && tableList.length > 0 && listInfo) {
            tableList.forEach((item, index) => {
              var model = {
                NID: item.NID,
                Path: '/uploads/' + item.Path,
                NTITLE: item.NTITLE,
                NDATETIME: that.formatDate(item.NDATETIME),
                NCONTENT: item.NCONTENT
              }
              that.resultList.push(model)
            })
            let pageListInfo = listInfo[0]
            that.queryParamters.pageIndex = pageListInfo.PageIndex
            that.queryParamters.pageSize = pageListInfo.PageSize
            that.queryParamters.totalNum = pageListInfo.TotalCount
          }
        } else {
          let errorMsg = '获取数据异常'
          if (data && !data.Msg) {
            errorMsg = data
          } else {
            errorMsg = data.Msg
          }
          Message.error(errorMsg)
        }
      })
    },
    handleSizeChange (val) {
      this.queryParamters.pageSize = val
      this.resultList = []
      this.initList()
    },
    handleCurrChange (val) {
      this.queryParamters.pageIndex = val
      this.resultList = []
      this.initList()
    },
    gotoNewsDetal (id) {
      const {href} = this.$router.resolve({
        path: '/newsDetail',
        query: {id: id, type: this.queryParamters.queryType}
      })
      window.open(href, '_blank')
    },
    formatDate (date) {
      let thisDate = new Date(date)
      let yy = thisDate.getFullYear()
      let MM = (thisDate.getMonth() + 1) < 10 ? '0' + (thisDate.getMonth() + 1) : (thisDate.getMonth() + 1)
      let dd = thisDate.getDate() < 10 ? '0' + thisDate.getDate() : thisDate.getDate()
      return yy + '-' + MM + '-' + dd
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mobile-width{
  width: 95% !important;
}
.el-main{
  padding: 0px;
}
.el-header{
    height: 70px !important;
    padding: 0px;
  }
.type-title{
    position: absolute;
    left: 19%;
    top: 70px;
    font-size: 58px;
    color: white;
    font-weight: 600;
}
.page-navugation {
    line-height: 50px;
    height: 50px;
    width: 63%;
   margin: 0px auto;
}
.page-navugation .navugation-left {
  text-align: left;
}
.navugation-left .navugation-root {
  font-weight: 600;
  font-size: 14px;
}
.navugation-left .navugation-cuur {
  font-size: 14px;
  color:#0550dc;
}
.page-navugation .navugation-right {
  text-align: right;
}
.navugation-right .el-button--primary {
    color: #FFF !important;
    background-color: #0550dc !important;
    border-color: #0550dc !important;
    border-radius: 0px !important;
}
.page-content {
  height: auto;
  padding-top: 20px;
  width: 63%;
  margin: 0px auto;
}
.page-content .result-item{
  height: 130px;
  margin: 20px 0px;
  border-bottom: 1px solid #dcdfe6;
}
.result-item.el-row:last-child {
  border-bottom: 0px solid #dcdfe6;
}
.page-content .result-item-img img{
  width: 100%;
  height: 110px;
  cursor: pointer;
}
.page-content  .result-item-text{
  height: 130px;
  padding: 5px 0px;
  text-align: left;
}
.result-item-text .result-item-title{
  font-size: 14px;
  font-weight: 700;
  height: 20px;
  line-height: 20px;
  cursor: pointer;
  -webkit-line-clamp: 1;
}
.result-item-text .result-item-content{
  font-size: 12px;
  color: ：#5a5b5d;
  height: 50px;
  margin: 5px 0px;
  line-height: 18px;
  cursor: pointer;
  -webkit-line-clamp: 3;
}
.result-item-text  .result-item-date{
  font-size: 12px;
  height: 20px;
  margin-top: 8px;
  color: #999999;
  line-height: 20px;
}
.page-content  .pagination-cust{
  margin: 8px 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/news/newsList.vue